import { SupportDocumentation } from "@/backend/models/supportDocumentation";
import { create } from "zustand";
import { SupportDocumentationController } from "../controllers/supportDocumentationController";
import { useGlobalStore } from "./GlobalStore";

export type SupportDocumentationStore = {
  supportDocumentation: SupportDocumentation[];
  reset: () => void;
  readAllSupportDocumentation: () => Promise<void>;
  createSupportDocumentation: (title: string, file: File, onProgress: (percent: number) => void) => Promise<void>;
  deleteSupportDocumentation: (id: string) => Promise<void>;
};

const initialState = {
  supportDocumentation: [] as SupportDocumentation[],
};

export const useSupportDocumentationStore = create<SupportDocumentationStore>()((set, get) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  readAllSupportDocumentation: async () => {
    const response = await new SupportDocumentationController().readAllSupportDocumentation();
    if (response.errors) return;
    set({ supportDocumentation: response.supportDocumentations.map((sd) => new SupportDocumentation(sd)) });
  },
  createSupportDocumentation: async (title: string, file: File, onProgress: (percent: number) => void) => {
    const response = await new SupportDocumentationController().createSupportDocumentation({ title, file: { fileName: file.name } });
    if (response.errors) return;
    if (response.status === 201) {
      const confirmed = await useGlobalStore.getState().uploadFile(response.supportDocumentation.file.id, response.uploadUrl, file, onProgress);

      if (!confirmed) {
        await get().deleteSupportDocumentation(response.supportDocumentation.id);
      }
      set({ supportDocumentation: [...get().supportDocumentation, new SupportDocumentation(response.supportDocumentation)] });
    }
  },
  deleteSupportDocumentation: async (id: string) => {
    const response = await new SupportDocumentationController().deleteSupportDocumentation(id);
    if (response.errors) return;
    set({ supportDocumentation: get().supportDocumentation.filter((sd) => sd.id !== id) });
  },
}));

